import React, { Component } from "react";

/**
 * Vizualizator document: afiseaza pagina PDF-ului randata ca imagine (merge pe orice
 * telefon, spre deosebire de PDF-ul in iframe) + buton de descarcare a PDF-ului original.
 *
 * Props: doc = { title, pdf, image, imageWebp } | null, onClose
 */
class PdfViewer extends Component {
  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown);
    if (this.props.doc) document.body.classList.add("modal-open");
  }

  componentDidUpdate(prevProps) {
    if (this.props.doc && !prevProps.doc) document.body.classList.add("modal-open");
    else if (!this.props.doc && prevProps.doc) document.body.classList.remove("modal-open");
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
    document.body.classList.remove("modal-open");
  }

  handleKeyDown = (e) => {
    if (this.props.doc && e.key === "Escape") this.props.onClose();
  };

  render() {
    const { doc, onClose } = this.props;
    if (!doc) return null;

    return (
      <div className="pdf-overlay" onClick={onClose}>
        <div className="pdf-viewer" role="dialog" aria-modal="true" aria-label={doc.title} onClick={(e) => e.stopPropagation()}>
          <div className="pdf-toolbar">
            <h2>{doc.title}</h2>
            <a className="pdf-download" href={doc.pdf} download>
              <i className="fa-solid fa-download"></i> Descarcă PDF
            </a>
            <button className="pdf-close" onClick={onClose} aria-label="Închide">
              ×
            </button>
          </div>
          <div className="pdf-page">
            <picture>
              <source srcSet={doc.imageWebp} type="image/webp" />
              <img src={doc.image} alt={doc.title} width="1400" height="1980" decoding="async" />
            </picture>
          </div>
        </div>
      </div>
    );
  }
}

export default PdfViewer;
